// extracted by mini-css-extract-plugin
export var gallery = "gallery-D1Z";
export var galleryItems = "galleryItems-10d";
export var swiper = "swiper-b_q";
export var image = "image-3oQ";
export var slide = "slide-KWT";
export var selected = "selected-2i7";
export var galleryHighlight = "galleryHighlight-1Xq";
export var arrows = "arrows-1M7";